import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Cashflow } from '@base/src/app/pages/configuration/panel/configuration.component';
import { QRInput } from 'src/app/models/qr-input.model';

@Component({
  selector: 'app-config-edit-cashflow-name',
  templateUrl: './config-edit-cashflow-name.component.html',
  styleUrls: ['./config-edit-cashflow-name.component.scss'],
})
export class ConfigEditCashflowNameComponent implements OnInit {
  @Input() value: Cashflow[] = [];
  @Output() change: EventEmitter<string> = new EventEmitter<string>();

  name: string = '';
  hasError: boolean = false;

  inputName: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Ingrese un nombre',
    errorMsg: '',
  };

  ngOnInit(): void {
    if (this.value && this.value.length > 0)
      this.name = this.value[0].description;
  }

  inputChange($event: any) {
    const VALIDATION_REGEX = /^[a-zA-Z0-9 _-]{3,20}$/;
    if (VALIDATION_REGEX.test($event)) {
      this.hasError = false;
      this.change.emit($event);
    } else {
      this.hasError = true;
      this.inputName.errorMsg =
        'El nombre debe tener entre 3 y 20 caracteres y no contener caracteres especiales.';
      this.change.emit('disabled'); 
    }
  }
  
}
